import React from 'react';
import Styles from './styles.module.css';
import Loader from '../../assets/svg/loader.svg';

const ImportMethodSelector = ({
    profiles,
    onProfileImport,
    onManualImport,
    isLoadingProfiles
}) => {
    return (
        <div className={Styles.container}>
            <div className={Styles.card}>
                <h3 className={Styles.title}>Import-Methode wählen</h3>
                <p className={Styles.subtitle}>
                    Wählen Sie ein vorkonfiguriertes Profil oder starten Sie einen individuellen Import
                </p>

                {isLoadingProfiles ? (
                    <div className={Styles.loading}>
                        <img src={Loader} width={30} height={30} alt="Loading" />
                        <span>Lade Profile...</span>
                    </div>
                ) : (
                    <div className={Styles.methodOptions}>
                        {/* Profile-based import section */}
                        <div className={Styles.section}>
                            <h4 className={Styles.sectionTitle}>
                                📋 Mit vorkonfiguriertem Profil importieren
                            </h4>
                            <p className={Styles.sectionDescription}>
                                Verwenden Sie ein gespeichertes Profil mit vordefinierten Kunden- und Adressdaten
                            </p>
                            
                            {(() => {
                                console.log('[ImportMethodSelector] Debug - All profiles:', profiles);
                                console.log('[ImportMethodSelector] Debug - Profiles with customer:', profiles.filter(p => p.customer));
                                return null;
                            })()}
                            
                            {profiles.length > 0 ? (
                                <div className={Styles.profileList}>
                                    {[...profiles].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((profile) => (
                                        <div
                                            key={profile.id}
                                            className={Styles.profileCard}
                                            onClick={() => onProfileImport(profile)}
                                        >
                                            <div className={Styles.profileHeader}>
                                                <h5 className={Styles.profileName}>{profile.name}</h5>
                                                <span className={Styles.profileType}>
                                                    {profile.importType === 'single-customer-multiple-orders' && 'Ein Kunde, mehrere Bestellungen'}
                                                    {profile.importType === 'single-customer-single-order' && 'Ein Kunde, eine Bestellung'}
                                                    {profile.importType === 'single-customer-single-order-with-prices' && 'Ein Kunde, eine Bestellung (mit Preisen)'}
                                                    {profile.importType === 'single-customer-single-order-without-prices' && 'Ein Kunde, eine Bestellung (ohne Preise)'}
                                                    {profile.importType === 'multiple-customers-multiple-orders' && 'Mehrere Kunden, mehrere Bestellungen'}
                                                    {!profile.importType && 'Standard Import'}
                                                </span>
                                            </div>
                                            <div className={Styles.profileCustomer}>
                                                <strong>Kunde:</strong> {
                                                    profile.customer 
                                                        ? (profile.customer.company || `${profile.customer.firstName} ${profile.customer.lastName}`)
                                                        : 'Noch nicht zugeordnet'
                                                }
                                                {(profile.importType === 'single-customer-single-order-with-prices' || 
                                                  profile.importType === 'single-customer-single-order') && (
                                                    <span className={Styles.priceIcon} title="Import mit Preisen">💰</span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className={Styles.noProfiles}>
                                    <p>Keine Profile gefunden (Total: {profiles.length}).</p>
                                    <p>Erstellen Sie Profile im Einstellungen-Tab.</p>
                                </div>
                            )}
                        </div>

                        {/* Manual import section - HIDDEN */}
                        <div className={Styles.section} style={{ display: 'none' }}>
                            <h4 className={Styles.sectionTitle}>
                                🔧 Individuellen Import starten
                            </h4>
                            <p className={Styles.sectionDescription}>
                                Wählen Sie Kunde, Adressen und Profil manuell aus
                            </p>
                            <button 
                                className={Styles.manualImportButton}
                                onClick={onManualImport}
                            >
                                Individuellen Import starten
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImportMethodSelector;